import type { AdminUserResponse } from '@/types/apps/admin-user.type';
import type { UserPayload, UserResponse } from '@/types/apps/user.type';
import type {
    ApiResponse,
    PaginatedResult,
    QueryParams,
} from '@/types/common/api.type';
import type { BaseApiClientInterface } from '@/types/service/base-api-client.interface';
import type { Deletable } from '@/types/service/deletable.interface';
import type { Indexable } from '@/types/service/indexable.interface';

import type { Updatable } from '@/types/service/updatable.interface';

type AdminUserListResponse = ApiResponse<PaginatedResult<AdminUserResponse>>;

export class AdminUserListService
    implements
        Indexable<ApiResponse<AdminUserListResponse>>,
        Updatable<ApiResponse<UserResponse>>,
        Deletable<ApiResponse<void>>
{
    public constructor(private apiClient: BaseApiClientInterface) {}

    protected endpoints = {
        base: () => '/api/admin/get-user-list',
        update: (id: string) => `/api/Admin/users/${id}`,
        delete: () => `/api/Admin/delete-user`,
    };

    public index(params?: QueryParams): Promise<any> {
        return this.apiClient.fetchApi(this.endpoints.base(), params);
    }

    public update(
        id: string,
        payload: UserPayload
    ): Promise<ApiResponse<UserResponse>> {
        return this.apiClient.putApi(this.endpoints.update(id), payload);
    }

    public destroy(
        ids: string[],
        isHardDeleted: boolean = false
    ): Promise<ApiResponse<void>> {
        return this.apiClient.destroyApi(
            this.endpoints.delete(),
            ids,
            isHardDeleted
        );
    }
}
